import React, { useState, useEffect, useRef } from "react";
import Header from "./Header";
import Footer from "./Footer";
import API_BASE_URL from "../Config";
import { useNavigate, useParams } from "react-router-dom";
import "./styles/Settings.css";
import "../styles/global.css";

/* ────────── SVG Icon System ────────── */
const Icon = ({ d, size = 18, stroke = 1.8 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={stroke}
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ display: "block", flexShrink: 0 }}
  >
    {d}
  </svg>
);

const SettingsIcon = (p) => (
  <Icon {...p} d={<><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" /></>} />
);
const CheckIcon = (p) => (
  <Icon {...p} d={<><path d="M20 6 9 17l-5-5" /></>} />
);
const XIcon = (p) => (
  <Icon {...p} d={<><path d="M18 6 6 18M6 6l12 12" /></>} />
);
const SearchIcon = (p) => (
  <Icon {...p} d={<><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></>} />
);
const SaveIcon = (p) => (
  <Icon {...p} d={<><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" /><polyline points="17 21 17 13 7 13 7 21" /><polyline points="7 3 7 8 15 8" /></>} />
);
const ChevronDownIcon = (p) => (
  <Icon {...p} d={<><path d="m6 9 6 6 6-6" /></>} />
);
const CheckCircleIcon = (p) => (
  <Icon {...p} d={<><circle cx="12" cy="12" r="10" /><path d="m9 12 2 2 4-4" /></>} />
);
const XCircleIcon = (p) => (
  <Icon {...p} d={<><circle cx="12" cy="12" r="10" /><path d="m15 9-6 6M9 9l6 6" /></>} />
);
const HeartPulseIcon = (p) => (
  <Icon {...p} d={<><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" /></>} />
);
const PillIcon = (p) => (
  <Icon {...p} d={<><path d="m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z" /><path d="m8.5 8.5 7 7" /></>} />
);
const LeafIcon = (p) => (
  <Icon {...p} d={<><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10z" /><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12" /></>} />
);
const FlaskIcon = (p) => (
  <Icon {...p} d={<><path d="M9 3h6l1 9H8L9 3z" /><path d="M6.5 12c-.8 1-1.5 2.1-1.5 3.5C5 18 7.1 20 10 20h4c2.9 0 5-2 5-4.5 0-1.4-.7-2.5-1.5-3.5" /><path d="M9 3v3M15 3v3" /></>} />
);
const UserMdIcon = (p) => (
  <Icon {...p} d={<><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></>} />
);
const ShoppingBagIcon = (p) => (
  <Icon {...p} d={<><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" /><line x1="3" y1="6" x2="21" y2="6" /><path d="M16 10a4 4 0 0 1-8 0" /></>} />
);
const ActivityIcon = (p) => (
  <Icon {...p} d={<><polyline points="22 12 18 12 15 21 9 3 6 12 2 12" /></>} />
);
const ClinicIcon = (p) => (
  <Icon {...p} d={<><path d="M3 21h18" /><path d="M5 21V7l7-4 7 4v14" /><path d="M9 21v-6h6v6" /><path d="M12 7v4M10 9h4" /></>} />
);
const StarIcon = (p) => (
  <Icon {...p} d={<><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></>} />
);
const UsersIcon = (p) => (
  <Icon {...p} d={<><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></>} />
);

/* ────────── Custom Multi-Select with selection-order preserved ────────── */
const OrderedMultiSelect = ({ label, field, options, setting, setSetting, sectionIcon }) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const dropdownRef = useRef(null);
  const triggerRef = useRef(null);
  const [dropUp, setDropUp] = useState(false);

  const selectedValues = setting[field] || [];

  // Compute dropdown position to avoid going off-screen
  const handleOpen = () => {
    if (!open && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;
      setDropUp(spaceBelow < 320 && spaceAbove > spaceBelow);
    }
    setOpen((v) => !v);
    setSearch("");
  };

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target) &&
        triggerRef.current &&
        !triggerRef.current.contains(e.target)
      ) {
        setOpen(false);
        setSearch("");
      }
    };
    if (open) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  const filteredOptions = options.filter((opt) =>
    opt.label.toLowerCase().includes(search.toLowerCase())
  );

  const toggleOption = (value) => {
    const current = setting[field] || [];
    if (current.includes(value)) {
      // Remove - preserve order of remaining
      setSetting({ ...setting, [field]: current.filter((v) => v !== value) });
    } else {
      // Add at the end - preserves selection order
      setSetting({ ...setting, [field]: [...current, value] });
    }
  };

  const selectAll = () => {
    // Select all in the order they appear in options (filtered if searching)
    const toAdd = filteredOptions.map((o) => o.value);
    const current = setting[field] || [];
    // Merge without duplicates, preserving existing order then appending new
    const merged = [...current, ...toAdd.filter((v) => !current.includes(v))];
    setSetting({ ...setting, [field]: merged });
  };

  const clearAll = () => {
    setSetting({ ...setting, [field]: [] });
  };

  // Remove a specific tag
  const removeTag = (e, value) => {
    e.stopPropagation();
    const current = setting[field] || [];
    setSetting({ ...setting, [field]: current.filter((v) => v !== value) });
  };

  // Get label for a value
  const getLabel = (value) => {
    const opt = options.find((o) => o.value === value);
    return opt ? opt.label : value;
  };

  return (
    <div className="st-field">
      <div className="st-label-row">
        <div className="st-label-icon">{sectionIcon}</div>
        <label className="st-label">{label}</label>
        <span className="st-count-badge">{selectedValues.length} selected</span>
      </div>

      {/* Trigger */}
      <div
        ref={triggerRef}
        className={`st-trigger ${open ? "is-open" : ""}`}
        onClick={handleOpen}
        tabIndex={0}
        onKeyDown={(e) => e.key === "Enter" && handleOpen()}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <div className="st-trigger-tags">
          {selectedValues.length === 0 ? (
            <span className="st-trigger-placeholder">Select {label}…</span>
          ) : (
            <>
              {selectedValues.slice(0, 3).map((val) => (
                <span key={val} className="st-tag">
                  {getLabel(val)}
                  <button
                    type="button"
                    className="st-tag-remove"
                    onClick={(e) => removeTag(e, val)}
                    aria-label={`Remove ${getLabel(val)}`}
                  >
                    <XIcon size={10} stroke={2.5} />
                  </button>
                </span>
              ))}
              {selectedValues.length > 3 && (
                <span className="st-tag st-tag-more">+{selectedValues.length - 3} more</span>
              )}
            </>
          )}
        </div>
        <span className="st-trigger-right">
          {selectedValues.length > 0 && (
            <button
              type="button"
              className="st-clear-all"
              onClick={(e) => { e.stopPropagation(); clearAll(); }}
              title="Clear all"
            >
              <XCircleIcon size={15} />
            </button>
          )}
          <span className={`st-chevron ${open ? "is-open" : ""}`}>
            <ChevronDownIcon size={16} />
          </span>
        </span>
      </div>

      {/* Dropdown — rendered in a fixed stacking context to avoid z-index issues */}
      {open && (
        <div
          ref={dropdownRef}
          className={`st-dropdown ${dropUp ? "drop-up" : "drop-down"}`}
          role="listbox"
          aria-multiselectable="true"
        >
          {/* Search + bulk actions */}
          <div className="st-dropdown-header">
            <div className="st-dropdown-search">
              <SearchIcon size={14} />
              <input
                type="text"
                placeholder={`Search ${label}…`}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onClick={(e) => e.stopPropagation()}
                autoFocus
              />
            </div>
            <div className="st-dropdown-actions">
              <button type="button" className="st-bulk-btn" onClick={selectAll}>
                <CheckIcon size={12} stroke={2.5} />
                {search ? "Select filtered" : "Select all"}
              </button>
              {selectedValues.length > 0 && (
                <button type="button" className="st-bulk-btn is-clear" onClick={clearAll}>
                  <XIcon size={12} stroke={2.5} />
                  Clear
                </button>
              )}
            </div>
          </div>

          {/* Options list */}
          <div className="st-options-list">
            {filteredOptions.length === 0 ? (
              <div className="st-no-results">No results for "{search}"</div>
            ) : (
              filteredOptions.map((opt) => {
                const isSelected = selectedValues.includes(opt.value);
                const selectionIndex = selectedValues.indexOf(opt.value);
                return (
                  <div
                    key={opt.value}
                    className={`st-option ${isSelected ? "is-selected" : ""}`}
                    role="option"
                    aria-selected={isSelected}
                    onClick={() => toggleOption(opt.value)}
                    tabIndex={0}
                    onKeyDown={(e) => e.key === "Enter" && toggleOption(opt.value)}
                  >
                    <span className="st-option-check">
                      {isSelected && <CheckIcon size={11} stroke={2.5} />}
                    </span>
                    <span className="st-option-label">{opt.label}</span>
                    {isSelected && (
                      <span className="st-order-badge">#{selectionIndex + 1}</span>
                    )}
                  </div>
                );
              })
            )}
          </div>

          {/* Footer info */}
          <div className="st-dropdown-footer">
            <span>{filteredOptions.length} item{filteredOptions.length !== 1 ? "s" : ""}</span>
            <span>{selectedValues.length} selected</span>
          </div>
        </div>
      )}

      {/* Selected items ordered display (below trigger, visible always) */}
      {selectedValues.length > 0 && (
        <div className="st-selected-order">
          {selectedValues.map((val, idx) => (
            <span key={val} className="st-order-tag">
              <span className="st-order-num">{idx + 1}</span>
              {getLabel(val)}
              <button
                type="button"
                className="st-order-tag-remove"
                onClick={() => toggleOption(val)}
                aria-label={`Remove ${getLabel(val)}`}
              >
                <XIcon size={10} stroke={2.5} />
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

/* ────────── Section Card ────────── */
const SectionCard = ({ title, icon, children }) => (
  <div className="st-section-card">
    <div className="st-section-header">
      <div className="st-section-icon">{icon}</div>
      <span className="st-section-title">{title}</span>
    </div>
    <div className="st-section-body">{children}</div>
  </div>
);

/* ────────── Main Component ────────── */
const Settings = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("authToken");

  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const [products, setProducts] = useState([]);
  const [frontproducts, setFrontProducts] = useState([]);
  const [treatments, setTreatments] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [categories, setCategories] = useState([]);
  const [clinics, setClinics] = useState([]);

  const [setting, setSetting] = useState({
    personal_care: [],
    liver_care: [],
    otc_product: [],
    vitamin: [],
    health_concern : [],
    clinic: [],
    treatment: [],
    doctor: [],
    top_specialist: [],
    team_doctors: [],
    products: [],
    delivery_charges: 0,
    hero_title: "",
    reviews_enabled: false,
  });

  /* ── Fetch functions (all original logic preserved exactly) ── */
  const fetchProducts = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}api/products_front`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (data.status) {
        setProducts(data.data);
        setFrontProducts(data.data);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const fetchTreatments = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}api/treatments_front`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (data.status) setTreatments(data.data);
    } catch (error) {
      console.error("Error fetching Treatments:", error);
    }
  };

  const fetchCategories = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}api/categories_front`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (data.status) setCategories(data.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const fetchClinics = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}api/clinic_front`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (data.status) setClinics(data.data);
    } catch (error) {
      console.error("Error fetching Clinics:", error);
    }
  };

  const fetchSetting = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}api/settings/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (data.status && data.setting) {
        const p = data.setting;
        setSetting({
          personal_care: (p.personal_care || []).map(String),
          liver_care: (p.liver_care || []).map(String),
          otc_product: (p.otc_product || []).map(String),
          vitamin: (p.vitamin || []).map(String),
          health_concern: (p.health_concern || []).map(String),
          clinic: (p.clinic || []).map(String),
          treatment: (p.treatment || []).map(String),
          doctor: (p.doctor || []).map(String),
          top_specialist: (p.top_specialist || []).map(String),
          team_doctors: (p.team_doctors || []).map(String),
          products: (p.products || []).map(String),
          delivery_charges: p.delivery_charges ?? 0,
          hero_title: p.hero_title || "",
          reviews_enabled: !!p.reviews_enabled,
        });
      }
    } catch (err) {
      console.error("Error fetching setting:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchDoctors = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}api/doctors_front`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (data.status) setDoctors(data.data);
    } catch (error) {
      console.error("Error fetching Doctors:", error);
    }
  };

  useEffect(() => {
    fetchCategories();
    fetchProducts();
    fetchTreatments();
    fetchDoctors();
    fetchClinics();
    fetchSetting();
  }, [id]);

  /* ── Options (no sorting — original order from API) ── */
  const categoryOptions = categories.map((cat) => ({
    value: String(cat.id),
    label: cat.name,
  }));

  const productOptions = products.map((p) => ({
    value: String(p.id),
    label: p.name,
  }));

  const frontProductOptions = frontproducts.map((p) => ({
    value: String(p.id),
    label: p.name,
  }));

  const treatmentOptions = treatments.map((p) => ({
    value: String(p.id),
    label: p.name,
  }));

  const doctorOptions = doctors.map((d) => ({
    value: String(d.id),
    label: d.name,
  }));

  const clinicOptions = clinics.map((c) => ({
    value: String(c.id),
    label: c.name,
  }));

  /* ── Submit (original logic preserved exactly) ── */
  const handleSubmit = async (e) => {
  e.preventDefault();
  setSubmitting(true);
  setMessage("");

  const formData = new FormData();

  // Array fields — join with comma
  const arrayFields = ["personal_care", "liver_care", "otc_product", "vitamin", "health_concern", "clinic", "treatment", "doctor", "top_specialist", "team_doctors", "products"];
  arrayFields.forEach((key) => {
    formData.append(key, (setting[key] || []).join(","));
  });

  // Non-array fields — append directly
  formData.append("delivery_charges", setting.delivery_charges ?? 0);
  formData.append("hero_title", setting.hero_title ?? "");
  formData.append("reviews_enabled", setting.reviews_enabled ? "1" : "0");

  try {
    const response = await fetch(`${API_BASE_URL}api/setting/${id}`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    });
    const data = await response.json();
    if (data.status) {
      setMessage("Settings updated successfully!");
      setMessageType("success");
      setTimeout(() => { setMessage(""); setMessageType(""); }, 4500);
    } else {
      setMessage("Failed to update Settings.");
      setMessageType("danger");
    }
  } catch (error) {
    console.error(error);
    setMessage("Something went wrong. Please try again.");
    setMessageType("danger");
  } finally {
    setSubmitting(false);
  }
};

  /* ── Loading ── */
  if (loading) {
    return (
      <div id="layout-wrapper">
        <Header />
        <div className="main-content">
          <div className="page-content">
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "60vh", flexDirection: "column", gap: 16 }}>
              <div style={{ width: 48, height: 48, borderRadius: "50%", border: "3px solid #d6efe2", borderTopColor: "#10b981", animation: "stSpin .8s linear infinite" }} />
              <p style={{ color: "#6b7a74", fontSize: 15, margin: 0 }}>Loading settings…</p>
            </div>
          </div>
        </div>
        <Footer />
        <style>{`@keyframes stSpin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  return (
    <>
      <div id="layout-wrapper">
        <Header />

        {submitting && (
          <div className="st-overlay">
            <div className="st-spinner" />
          </div>
        )}

        <div className="main-content">
          <div className="page-content">
            <div className="st-shell">

              {/* ── Page Header ── */}
              <div className="st-head">
                <div className="st-head-left">
                  <div className="st-head-icon">
                    <SettingsIcon size={22} />
                  </div>
                  <div>
                    <h2>Settings</h2>
                    <p>Configure homepage sections and featured content. Selection order is preserved.</p>
                  </div>
                </div>
              </div>

              {/* ── Alert ── */}
              {message && (
                <div className={`st-alert st-alert-${messageType}`}>
                  {messageType === "success"
                    ? <CheckCircleIcon size={18} />
                    : <XCircleIcon size={18} />}
                  {message}
                </div>
              )}

              <form onSubmit={handleSubmit}>

                {/* ── Section: Homepage Hero ── */}
                <SectionCard title="Homepage Hero" icon={<ActivityIcon size={17} />}>
                  <div className="st-field">
                    <div className="st-label-row">
                      <label className="st-label">Hero Title</label>
                    </div>
                    <textarea
                      className="form-control"
                      rows={2}
                      value={setting.hero_title ?? ""}
                      onChange={(e) => setSetting({ ...setting, hero_title: e.target.value })}
                      placeholder={"Consult trusted Ayurvedic doctors\nand order authentic medicines online"}
                    />
                    <p style={{ fontSize: 12, color: "#6b7a74", marginTop: 6 }}>
                      Use a new line where you want the title to break onto a second line.
                    </p>
                  </div>
                </SectionCard>

                {/* ── Section 1: Category Sections ── */}
                <SectionCard title="Category Sections" icon={<ActivityIcon size={17} />}>
                  <OrderedMultiSelect
                    label="Personal Care"
                    field="personal_care"
                    options={categoryOptions}
                    setting={setting}
                    setSetting={setSetting}
                    sectionIcon={<HeartPulseIcon size={14} />}
                  />
                  <OrderedMultiSelect
                    label="Liver Care"
                    field="liver_care"
                    options={categoryOptions}
                    setting={setting}
                    setSetting={setSetting}
                    sectionIcon={<LeafIcon size={14} />}
                  />
                  <OrderedMultiSelect
                    label="Vitamin"
                    field="vitamin"
                    options={categoryOptions}
                    setting={setting}
                    setSetting={setSetting}
                    sectionIcon={<FlaskIcon size={14} />}
                  />
                </SectionCard>


                <SectionCard title="Category Sections" icon={<ActivityIcon size={17} />}>
                  
                  <OrderedMultiSelect
                    label="health_concern"
                    field="health_concern"
                    options={categoryOptions}
                    setting={setting}
                    setSetting={setSetting}
                    sectionIcon={<FlaskIcon size={14} />}
                  />
                </SectionCard>

                {/* ── Section: Clinics ── */}
                <SectionCard title="Clinic Sections" icon={<ClinicIcon size={17} />}>
                  <OrderedMultiSelect
                    label="clinic"
                    field="clinic"
                    options={clinicOptions}
                    setting={setting}
                    setSetting={setSetting}
                    sectionIcon={<ClinicIcon size={14} />}
                  />
                </SectionCard>

                {/* ── Section 2: Product Sections ── */}
                <SectionCard title="Product Sections" icon={<ShoppingBagIcon size={17} />}>
                  <OrderedMultiSelect
                    label="OTC Product"
                    field="otc_product"
                    options={productOptions}
                    setting={setting}
                    setSetting={setSetting}
                    sectionIcon={<PillIcon size={14} />}
                  />
                  <OrderedMultiSelect
                    label="Products"
                    field="products"
                    options={frontProductOptions}
                    setting={setting}
                    setSetting={setSetting}
                    sectionIcon={<ShoppingBagIcon size={14} />}
                  />
                </SectionCard>

                {/* ── Section 3: Medical Staff & Treatments ── */}
                <SectionCard title="Medical Staff & Treatments" icon={<UserMdIcon size={17} />}>
                  <OrderedMultiSelect
                    label="Treatments"
                    field="treatment"
                    options={treatmentOptions}
                    setting={setting}
                    setSetting={setSetting}
                    sectionIcon={<ActivityIcon size={14} />}
                  />
                  <OrderedMultiSelect
                    label="Doctors"
                    field="doctor"
                    options={doctorOptions}
                    setting={setting}
                    setSetting={setSetting}
                    sectionIcon={<UserMdIcon size={14} />}
                  />
                  <OrderedMultiSelect
                    label="Top Ayurvedic Specialists"
                    field="top_specialist"
                    options={doctorOptions}
                    setting={setting}
                    setSetting={setSetting}
                    sectionIcon={<StarIcon size={14} />}
                  />
                </SectionCard>

                {/* ── Section: About Us — Meet Our Team ── */}
                <SectionCard title="About Us — Meet Our Team" icon={<UsersIcon size={17} />}>
                  <OrderedMultiSelect
                    label="Meet Our Team (About Us page)"
                    field="team_doctors"
                    options={doctorOptions}
                    setting={setting}
                    setSetting={setSetting}
                    sectionIcon={<UsersIcon size={14} />}
                  />
                </SectionCard>

                <SectionCard title="Charges" icon={<ActivityIcon size={17} />}>
                  <div className="st-field">
                    <div className="st-label-row">
                      <label className="st-label">Delivery Charges (₹)</label>
                    </div>
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      className="form-control"
                      value={setting.delivery_charges ?? ""}
                      onChange={e => setSetting({ ...setting, delivery_charges: e.target.value })}
                      placeholder="0.00"
                    />
                  </div>
                </SectionCard>

                {/* ── Section: Product Reviews ── */}
                <SectionCard title="Product Reviews" icon={<StarIcon size={17} />}>
                  <div className="st-field">
                    <div className="st-toggle-row">
                      <div>
                        <label className="st-label" style={{ marginBottom: 4, display: "block" }}>
                          Enable "Write a Review" on My Profile
                        </label>
                        <p style={{ fontSize: 12, color: "#6b7a74", margin: 0 }}>
                          When off, customers cannot see or submit product reviews from their
                          order history. This is disabled by default.
                        </p>
                      </div>
                      <label className="st-switch">
                        <input
                          type="checkbox"
                          checked={!!setting.reviews_enabled}
                          onChange={(e) => setSetting({ ...setting, reviews_enabled: e.target.checked })}
                        />
                        <span className="st-switch-slider" />
                      </label>
                    </div>
                  </div>
                </SectionCard>

                {/* ── Submit Bar ── */}
                <div className="st-submit-bar">
                  <button type="button" className="st-btn-cancel" onClick={() => navigate(-1)}>
                    Cancel
                  </button>
                  <button type="submit" className="st-btn-submit" disabled={submitting}>
                    <SaveIcon size={16} />
                    {submitting ? "Saving…" : "Update Settings"}
                  </button>
                </div>

              </form>

            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default Settings;